/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Cenorion Tenant Edge API (DEV)
 * Live API Gateway routes, documented from backend contracts/rest.
 * OpenAPI spec version: live
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DashboardDevicesByModelResponse,
  DashboardDevicesByProgramResponse,
  DashboardServiceTabResponse,
  DashboardSummaryResponse,
  GetDashboardDevicesByModelParams,
  GetDashboardSummaryParams,
  ProblemDetails
} from '../../models';

import { apiMutator } from '../../../http/mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Deployed on API Gateway but not documented in backend contracts/rest.
 * @summary GET /v1/dashboard/attention
 */
export const getDashboardAttention = (

 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<void>(
      {url: `/v1/dashboard/attention`, method: 'GET', signal
    },
      options);
    }




export const getGetDashboardAttentionQueryKey = () => {
    return [
    `/v1/dashboard/attention`
    ] as const;
    }


export const getGetDashboardAttentionQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardAttention>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardAttention>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardAttentionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardAttention>>> = ({ signal }) => getDashboardAttention(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardAttention>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDashboardAttentionQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardAttention>>>
export type GetDashboardAttentionQueryError = unknown


export function useGetDashboardAttention<TData = Awaited<ReturnType<typeof getDashboardAttention>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardAttention>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardAttention>>,
          TError,
          Awaited<ReturnType<typeof getDashboardAttention>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDashboardAttention<TData = Awaited<ReturnType<typeof getDashboardAttention>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardAttention>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardAttention>>,
          TError,
          Awaited<ReturnType<typeof getDashboardAttention>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDashboardAttention<TData = Awaited<ReturnType<typeof getDashboardAttention>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardAttention>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary GET /v1/dashboard/attention
 */

export function useGetDashboardAttention<TData = Awaited<ReturnType<typeof getDashboardAttention>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardAttention>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDashboardAttentionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Top models by device count, each bar segmented by program in the same vocabulary and order as the donut.
 * @summary Program breakdown — one stacked bar per device model
 */
export const getDashboardDevicesByModel = (
    params?: GetDashboardDevicesByModelParams,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<DashboardDevicesByModelResponse>(
      {url: `/v1/dashboard/devices/by-model`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDashboardDevicesByModelQueryKey = (params?: GetDashboardDevicesByModelParams,) => {
    return [
    `/v1/dashboard/devices/by-model`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDashboardDevicesByModelQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardDevicesByModel>>, TError = ProblemDetails>(params?: GetDashboardDevicesByModelParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardDevicesByModel>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardDevicesByModelQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardDevicesByModel>>> = ({ signal }) => getDashboardDevicesByModel(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardDevicesByModel>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDashboardDevicesByModelQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardDevicesByModel>>>
export type GetDashboardDevicesByModelQueryError = ProblemDetails


export function useGetDashboardDevicesByModel<TData = Awaited<ReturnType<typeof getDashboardDevicesByModel>>, TError = ProblemDetails>(
 params: undefined |  GetDashboardDevicesByModelParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardDevicesByModel>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardDevicesByModel>>,
          TError,
          Awaited<ReturnType<typeof getDashboardDevicesByModel>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDashboardDevicesByModel<TData = Awaited<ReturnType<typeof getDashboardDevicesByModel>>, TError = ProblemDetails>(
 params?: GetDashboardDevicesByModelParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardDevicesByModel>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardDevicesByModel>>,
          TError,
          Awaited<ReturnType<typeof getDashboardDevicesByModel>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDashboardDevicesByModel<TData = Awaited<ReturnType<typeof getDashboardDevicesByModel>>, TError = ProblemDetails>(
 params?: GetDashboardDevicesByModelParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardDevicesByModel>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Program breakdown — one stacked bar per device model
 */

export function useGetDashboardDevicesByModel<TData = Awaited<ReturnType<typeof getDashboardDevicesByModel>>, TError = ProblemDetails>(
 params?: GetDashboardDevicesByModelParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardDevicesByModel>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDashboardDevicesByModelQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * The donut: `total` in the centre, one segment per program.
 * @summary Status breakdown — every device in exactly one program
 */
export const getDashboardDevicesByProgram = (

 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<DashboardDevicesByProgramResponse>(
      {url: `/v1/dashboard/devices/by-program`, method: 'GET', signal
    },
      options);
    }




export const getGetDashboardDevicesByProgramQueryKey = () => {
    return [
    `/v1/dashboard/devices/by-program`
    ] as const;
    }


export const getGetDashboardDevicesByProgramQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardDevicesByProgram>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardDevicesByProgram>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardDevicesByProgramQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardDevicesByProgram>>> = ({ signal }) => getDashboardDevicesByProgram(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardDevicesByProgram>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDashboardDevicesByProgramQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardDevicesByProgram>>>
export type GetDashboardDevicesByProgramQueryError = ProblemDetails


export function useGetDashboardDevicesByProgram<TData = Awaited<ReturnType<typeof getDashboardDevicesByProgram>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardDevicesByProgram>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardDevicesByProgram>>,
          TError,
          Awaited<ReturnType<typeof getDashboardDevicesByProgram>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDashboardDevicesByProgram<TData = Awaited<ReturnType<typeof getDashboardDevicesByProgram>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardDevicesByProgram>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardDevicesByProgram>>,
          TError,
          Awaited<ReturnType<typeof getDashboardDevicesByProgram>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDashboardDevicesByProgram<TData = Awaited<ReturnType<typeof getDashboardDevicesByProgram>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardDevicesByProgram>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Status breakdown — every device in exactly one program
 */

export function useGetDashboardDevicesByProgram<TData = Awaited<ReturnType<typeof getDashboardDevicesByProgram>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardDevicesByProgram>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDashboardDevicesByProgramQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Deployed on API Gateway but not documented in backend contracts/rest.
 * @summary GET /v1/dashboard/services
 */
export const getDashboardServices = (

 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<void>(
      {url: `/v1/dashboard/services`, method: 'GET', signal
    },
      options);
    }




export const getGetDashboardServicesQueryKey = () => {
    return [
    `/v1/dashboard/services`
    ] as const;
    }


export const getGetDashboardServicesQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardServices>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardServices>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardServicesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardServices>>> = ({ signal }) => getDashboardServices(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardServices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDashboardServicesQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardServices>>>
export type GetDashboardServicesQueryError = unknown


export function useGetDashboardServices<TData = Awaited<ReturnType<typeof getDashboardServices>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardServices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardServices>>,
          TError,
          Awaited<ReturnType<typeof getDashboardServices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDashboardServices<TData = Awaited<ReturnType<typeof getDashboardServices>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardServices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardServices>>,
          TError,
          Awaited<ReturnType<typeof getDashboardServices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDashboardServices<TData = Awaited<ReturnType<typeof getDashboardServices>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardServices>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary GET /v1/dashboard/services
 */

export function useGetDashboardServices<TData = Awaited<ReturnType<typeof getDashboardServices>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardServices>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDashboardServicesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * `states` is the service's closed PLM §8 state set in PLM order, zero counts included, so the bar segments and the cards render straight off the array.
 * @summary One Services tab — state bar, state cards
 */
export const getDashboardServiceTab = (
    service: 'dfpost' | 'sc' | 'dfpre' | 'sim',
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<DashboardServiceTabResponse>(
      {url: `/v1/dashboard/services/${service}`, method: 'GET', signal
    },
      options);
    }




export const getGetDashboardServiceTabQueryKey = (service: 'dfpost' | 'sc' | 'dfpre' | 'sim',) => {
    return [
    `/v1/dashboard/services/${service}`
    ] as const;
    }


export const getGetDashboardServiceTabQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardServiceTab>>, TError = ProblemDetails>(service: 'dfpost' | 'sc' | 'dfpre' | 'sim', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardServiceTab>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardServiceTabQueryKey(service);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardServiceTab>>> = ({ signal }) => getDashboardServiceTab(service, requestOptions, signal);





   return  { queryKey, queryFn, enabled: service !== null && service !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardServiceTab>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDashboardServiceTabQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardServiceTab>>>
export type GetDashboardServiceTabQueryError = ProblemDetails


export function useGetDashboardServiceTab<TData = Awaited<ReturnType<typeof getDashboardServiceTab>>, TError = ProblemDetails>(
 service: 'dfpost' | 'sc' | 'dfpre' | 'sim', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardServiceTab>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardServiceTab>>,
          TError,
          Awaited<ReturnType<typeof getDashboardServiceTab>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDashboardServiceTab<TData = Awaited<ReturnType<typeof getDashboardServiceTab>>, TError = ProblemDetails>(
 service: 'dfpost' | 'sc' | 'dfpre' | 'sim', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardServiceTab>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardServiceTab>>,
          TError,
          Awaited<ReturnType<typeof getDashboardServiceTab>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDashboardServiceTab<TData = Awaited<ReturnType<typeof getDashboardServiceTab>>, TError = ProblemDetails>(
 service: 'dfpost' | 'sc' | 'dfpre' | 'sim', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardServiceTab>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One Services tab — state bar, state cards
 */

export function useGetDashboardServiceTab<TData = Awaited<ReturnType<typeof getDashboardServiceTab>>, TError = ProblemDetails>(
 service: 'dfpost' | 'sc' | 'dfpre' | 'sim', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardServiceTab>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDashboardServiceTabQueryOptions(service,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Each tile carries its value, a delta against the previous day (`change_window_days` = 1; absent when that day has no value) and a `trend` of one point per day for the sparkline.
 * @summary The four KPI tiles — Total devices, Enrolled, Active %, Locked %
 */
export const getDashboardSummary = (
    params?: GetDashboardSummaryParams,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<DashboardSummaryResponse>(
      {url: `/v1/dashboard/summary`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDashboardSummaryQueryKey = (params?: GetDashboardSummaryParams,) => {
    return [
    `/v1/dashboard/summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDashboardSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = ProblemDetails>(params?: GetDashboardSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardSummary>>> = ({ signal }) => getDashboardSummary(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDashboardSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardSummary>>>
export type GetDashboardSummaryQueryError = ProblemDetails


export function useGetDashboardSummary<TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = ProblemDetails>(
 params: undefined |  GetDashboardSummaryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardSummary>>,
          TError,
          Awaited<ReturnType<typeof getDashboardSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDashboardSummary<TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = ProblemDetails>(
 params?: GetDashboardSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardSummary>>,
          TError,
          Awaited<ReturnType<typeof getDashboardSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDashboardSummary<TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = ProblemDetails>(
 params?: GetDashboardSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The four KPI tiles — Total devices, Enrolled, Active %, Locked %
 */

export function useGetDashboardSummary<TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = ProblemDetails>(
 params?: GetDashboardSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDashboardSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






